// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"00894e3c","787":"a3eff41e"}[chunkId] + ".chunk.js";
};